import { render, staticRenderFns } from "./DetailsInformationFrundInfo.vue?vue&type=template&id=7f9804af&"
import script from "./DetailsInformationFrundInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationFrundInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports